export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Alcance de Vinculacion de inventario',
	plural_model_name_spanish: 'Alcances de Vinculacion de inventario',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}